export type SeasonalEventId = 'halloween' | 'christmas' | 'easter'

export interface SeasonalEventForInstanceKey {
  name: SeasonalEventId
  start: Date
}

/**
 * Identifie l’occurrence (ex. easter:2026). L’année est celle de `start` (15 déc pour Noël).
 */
export function getSeasonalEventInstanceKey(event: SeasonalEventForInstanceKey): string {
  const year = event.start.getFullYear()
  return `${event.name}:${year}`
}

export function getLocalDayKey(): string {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export interface SeasonalWelcomeModalCopy {
  title: string
  /** Texte riche possible : paragraphes séparés par \n\n pour le template */
  body: string
  shortLabel: string
}

const WELCOME_BY_EVENT: Record<SeasonalEventId, SeasonalWelcomeModalCopy> = {
  halloween: {
    title: 'Joyeux Halloween sur Mon Orga',
    shortLabel: 'Halloween',
    body:
      'Pour la période d’Halloween, Mon Orga affiche quelques animations légères : décor près du logo, élément en bas à droite et un petit compagnon qui suit votre curseur sur ordinateur.\n\n' +
      'Vous pouvez désactiver chaque effet ci-dessous ou ne plus afficher cette fenêtre jusqu’au prochain événement saisonnier.',
  },
  christmas: {
    title: 'Fêtes de fin d’année sur Mon Orga',
    shortLabel: 'Fêtes',
    body:
      'Mon Orga vous souhaite de belles fêtes. Des décorations discrètes sont proposées autour du logo, dans un coin de l’écran et au niveau du curseur.\n\n' +
      'Ajustez les options comme vous le souhaitez, ou indiquez que vous ne souhaitez plus voir cette fenêtre pour cet événement.',
  },
  easter: {
    title: 'Pâques sur Mon Orga',
    shortLabel: 'Pâques',
    body:
      'Pour Pâques, Mon Orga affiche des touches décoratives : près du logo, en bas à droite, et un emoji qui accompagne le curseur sur bureau.\n\n' +
      'Vous pouvez les activer ou les désactiver individuellement, et choisir de ne plus afficher ce message jusqu’au prochain événement.',
  },
}

export function getSeasonalWelcomeModalCopy(eventId: SeasonalEventId): SeasonalWelcomeModalCopy {
  return WELCOME_BY_EVENT[eventId]
}
